<template>
  <div class="all clearfix">
    <div class="mdCont bgff">
      <div class="grid pb30">
        <div class="screen mt5">
          <div class="item clearfix">
            <span class="zu clearfix">
              <span class="name">地区</span>
              <city @cityCallback="citySelect1" ref="citySelect"></city>
            </span>
            <div class="zu corm">
              <span class="name">时间</span>
              <span
                class="element"
                :class="{ curr: curRank == index }"
                v-for="(item, index) in rankList"
                @click="dropDownChoose(index, item, 1)"
                :key="index"
                >{{ index }}</span
              >
            </div>
            <span class="zu yujin-text clearfix" v-if="isShowCustom">
              <span class="drop-down">
                <vue-datepicker-local
                  ref="timeSelect"
                  v-model="timeRange"
                  format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  show-buttons
                  clearable
                  @clear="selectedDate"
                  @confirm="selectedDate"
                  placeholder="请选择时间"
                />
              </span>
            </span>
          </div>
        </div>
        <div class="warp mt5 clearfix">
          <div class="warp-body mh270 clearfix">
            <div class="w650 fl">
              <div class="echart-warp h545">
                <div class="no-data pt40" v-if="nodata.mapChartData">
                  <img src="static/images/no_data.png" class="img" />
                  <span class="text">没有数据哦...</span>
                </div>
                <mapChart
                  id="mapEchart"
                  :dataArray="mapChartData"
                  :areaName="curMapName"
                  v-if="mapChartData != ''"
                  :isShowTit="showTit"
                  :showEmotion="true"
                ></mapChart>
              </div>

              <div class="mt30 pt20">
                <div class="grid-header clearfix">
                  <h2 class="title fl">热点事件</h2>
                  <div class="gridHeader-r fr">
                    <span class="zu clearfix">
                      <span class="drop-down">
                        <button class="btn btn-lightblue">
                          {{ curMood }}<i class="icons fr"></i>
                        </button>
                        <ul class="option">
                          <li
                            v-for="(item, index) in moodList"
                            @click="dropDownChoose(index, '', 2)"
                            :key="index"
                          >
                            {{ index }}
                          </li>
                        </ul>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="no-data pt40" v-if="nodata.hotAllRank">
                  <img src="static/images/no_data.png" class="img" />
                  <span class="text">没有数据哦...</span>
                </div>
                <ul class="news mt10">
                  <li v-for="(item, index) in hotAllRank" :key="index">
                    <a class="cr3d" :href="item.news_url" target="_blank">
                      <span class="md10 ovhidden fl" :title="item.news_title"
                        ><i class="order">{{ index + 1 }}</i
                        >{{ item.news_title }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="emotion-r mt10 fr">
              <div class="grid-d clearfix">
                <div class="grid-header clearfix">
                  <h2 class="title fl">地区</h2>
                </div>
                <div class="emotionTxt mt10">
                  <span>{{ curFullName }}</span>
                </div>
              </div>
              <div class="grid-d mt15 clearfix">
                <div class="grid-header clearfix">
                  <h2 class="title fl">情绪判断</h2>
                </div>
                <div class="pd20 mt10 emotionTxt md10" v-if="curEmot != ''">
                  <strong
                    class="fs16"
                    :style="'color:' + emotIcon[curEmot].color"
                    >{{ curEmot }}</strong
                  >
                  <strong
                    class="fs16 ml10"
                    :style="'color:' + emotIcon[curEmot].color"
                    v-if="curEmotPer != ''"
                    >{{ curEmotPer }}</strong
                  >
                  <i class="emotIcon fr" :class="emotIcon[curEmot].icons"></i>
                </div>
                <div class="echart-warp mt10 h200">
                  <pieChart
                    id="media"
                    :dataArray="pieEmotionData"
                    v-if="pieEmotionData != ''"
                    :colorArr="pieColorArr"
                    :showLegend="false"
                  ></pieChart>
                  <div class="no-data" v-if="nodata.pieEmotionData">
                    <img src="static/images/no_data.png" class="img" /><span
                      class="text"
                      >没有数据哦...</span
                    >
                  </div>
                </div>
              </div>
              <div class="grid-d clearfix">
                <div class="grid-header clearfix">
                  <h2 class="title fl">情绪分析</h2>
                </div>
                <div class="echart-warp h270">
                  <lineChart
                    id="hotEvent"
                    :dataArray="emotionData"
                    v-if="emotionData != ''"
                    :colorArr="colorArr"
                    :isShowArea="false"
                    gridBot="60"
                  ></lineChart>
                  <div class="no-data" v-if="nodata.emotionData">
                    <img src="static/images/no_data.png" class="img" /><span
                      class="text"
                      >没有数据哦...</span
                    >
                  </div>
                </div>
              </div>
              <div class="grid-d clearfix">
                <div class="grid-header clearfix">
                  <h2 class="title fl">区域主题词</h2>
                </div>
                <div class="echart-warp h200">
                  <div class="no-data" v-if="nodata.defaultWords">
                    <img src="static/images/no_data.png" class="img" /><span
                      class="text"
                      >没有数据哦...</span
                    >
                  </div>
                  <cloudChart
                    id="wordCloud"
                    :dataArray="defaultWords"
                    v-if="defaultWords != ''"
                  ></cloudChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mapChart from "../components/echart/mapChart";
import pieChart from "../components/echart/pieChart.vue";
import cloudChart from "../components/echart/wordCloud.vue";
import lineChart from "../components/echart/lineChart.vue";
import city from "../components/city.vue";
import VueDatepickerLocal from "vue-datepicker-local";
export default {
  components: {
    mapChart,
    VueDatepickerLocal,
    city,
    cloudChart,
    lineChart,
    pieChart,
  },
  data() {
    return {
      hotTopicsList: [],
      showTit: true,
      defaultImg: 'this.src="static/images/default.png"',
      tags: "全部",
      curRank: "近七日",
      curRankType: 1,
      rankList: {
        "24小时": 1,
        今天: 1,
        昨天: 1,
        近三日: 3,
        近七日: 7,
        自定义: 1,
      },
      curMedia: "全部", //当前媒体
      mediaList: { 全部: 4, 网页: 1, 微信: 2, 微博: 3, 头条: 5, 抖音: 6 }, //媒体下拉列表
      curCity: "全国",
      tagsList: [],
      mapChartData: [], //地图数据
      hotAllRank: [], //热点事件
      curMood: "",
      moodList: {
        喜悦: "乐",
        赞扬: "好",
        愤怒: "怒",
        悲伤: "哀",
        恐惧: "惧",
        厌恶: "恶",
        惊奇: "惊",
      },
      datas2: {},
      provinceList: [], //地图省份选择列表
      provinceFullList: [], //地图省份选择列表全称
      curMapName: "全国", //
      curFullName: "全国", //
      curProvMapName: "", //省
      curCityMapName: "", //市
      curAreaMapName: "", //县区
      pageCur: 1,
      pageNum: 10,
      dataCount: 0,
      isShowCustom: false,
      timeRange: [],
      nowTime: new Date(), //时间选择
      startTime: null,
      endTime: null,
      maxTime: new Date(),
      province: "", //省份
      city: "", //城市
      county: "", //区县
      isShowMore: false,
      isShowEnd: false,
      pieEmotionData: [], //情绪判断
      emotionData: [], //情绪分析
      pieColorArr: [],
      colorArr: [
        "#2acc54",
        "#0095eb",
        "#ff5268",
        "#999",
        "#00afad",
        "#bc4df0",
        "#bdbf06",
      ],
      defaultWords: [], //热门主题词词云图
      wordColors: [
        "#3c77ce",
        "#bf3a54",
        "#2fa130",
        "#ce393a",
        "#36accd",
        "#c64c65",
      ],
      curEmot: "",
      curEmotPer: 0,
      emotIcon: {
        愤怒: { icons: "emotfl-icon", color: "#ff5268", val: 2 },
        悲伤: { icons: "emotbs-icon", color: "#999", val: 3 },
        恐惧: { icons: "emotkj-icon", color: "#00afad", val: 4 },
        厌恶: { icons: "emotyw-icon", color: "#bc4df0", val: 5 },
        惊奇: { icons: "emotjq-icon", color: "#bdbf06", val: 6 },
        喜悦: { icons: "emotxy-icon", color: "#2acc54", val: 7 },
        赞扬: { icons: "emotzy-icon", color: "#0095eb", val: 8 },
        中性: { icons: "emotzx-icon", color: "#e5882e", val: 1 },
      },
      nodata: {
        mornData: false,
        evenData: false,
        mapChartData: false,
        hotAllRank: false,
        emotionData: false,
        defaultWords: false,
        pieEmotionData: false,
      },
      load: {
        defaultWords: true,
      },
    };
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tags = that.$route.query.type;
      //let newTime = new Date();
      that.getToday(that.curRank, 7);
      that.dataAjax();
      that.$utils.screenHeight();
    });
  },
  beforeDestroy() {
    clearInterval(this.setTimer);
  },
  watch: {
    $route() {
      let that = this;
      that.tags = that.$route.query.type;
      that.$refs.left.curType = that.tags;
      that.clearListData();
    },
  },
  methods: {
    // 获取当前时间和24小时时间
    getToday(name, type) {
      let max = "";
      let min = "";
      let nowTime = this.$utils.getNowDate();

      let n = nowTime.split(" ");
      let n1 = n[0].split("-");
      let n2 = n[1].split(":");
      let oldTime = this.$utils.getBeforeDay(nowTime, type);
      let o = oldTime.split("-");

      if(type==3||type==7){//近3日和7日截止到昨天
         nowTime= this.$utils.getBeforeDay(nowTime, 1);
          n1 =nowTime.split("-");
      }
      max = new Date(n1[0], n1[1] - 1, n1[2], n2[0], n2[1], n2[2]);

        // "24小时": 1,
        // 今天: 1,
        // 昨天: 1,
        // 近三日: 3,
        // 近七日: 7,
        // 自定义: 1,
      if (name == "今天") {
        min = new Date(n1[0], n1[1] - 1, n1[2], 0, 0, 0);
      } else if (name == "昨天") {
        min = new Date(o[0], o[1] - 1, o[2], 0, 0, 0);
        max = new Date(o[0], o[1] - 1, o[2], 23, 59, 59);
      }else if (name == "24小时") {
        min = new Date(o[0], o[1] - 1, o[2], n2[0], n2[1], n2[2]);
      }else {
        min = new Date(o[0], o[1] - 1, o[2], 0, 0, 0);
        max = new Date(n1[0], n1[1] - 1, n1[2], 23, 59,59);
      }
      this.timeRange = [min, max];
      //进页面获取时间数据
      this.startTime = this.$utils.dateConversion(min, 1);
      this.endTime = this.$utils.dateConversion(max, 1);
    },
    //下拉选择
    dropDownChoose(name, type, num) {
      let that = this;
      if (num === 1) {
        //that.curRankType = type;
        that.curRank = name;
        if (name == "自定义") {
          that.isShowCustom = true;
          return;
        } else {
          that.isShowCustom = false;
          that.getToday(name, type);
        }
        // if(name=="今天" || name=="24小时"){
        //     that.getToday(name)
        // }
        that.clearListData();
      } else if (num === 2) {
        that.curMood = name;
        that.getMapEvent();
      }
    },
    dataAjax(type) {
      let that = this,
        tags = "",
        province = "",
        city = "",
        county = "";
      tags = that.tags == "全部" ? "" : that.tags;
      that.$parent.loadModal(true, "数据加载中...");
      that.$axios.get("static/city.json").then((r) => {
        that.provinceList = r.data.shortProvince;
        that.provinceFullList = r.data.province;
      });
      if (that.curMapName != "全国") {
        province = that.curMapName;
      }
      if (type == 2 || type == 5) {
        province = that.curProvMapName;
        city = that.curCityMapName;
      }
      if (type == 3 || type == 4) {
        province = that.curProvMapName;
        city = that.curCityMapName;
        county = that.curAreaMapName;
      }
      if (type == 4 && city != "") {
        that.curMapName = city;
      }

      //console.log(that.curMapName);
      let time = that.$utils.dateConversion(that.nowTime, 0);

      if (county == "" || type == 4) {
        let datas = {
          type: 1,
          province: province,
          date: time,
          city: city,
          start_time: that.startTime,
          end_time: that.endTime,
        };
        if (type == 5 && county == "") {
          datas.city = "";
          that.curMapName = province;
        }
        //热点事件地图
        that.$api.get("news/emotion/map", datas, (r) => {
          that.$parent.returnCode(r, function () {
            let data = r.data;
            data.forEach((ele) => {
              ele.value1 = ele.value;
              if (ele.value != "暂无") {
                ele.value = that.emotIcon[ele.mood].val;
              }
            });
            that.mapChartData = data;
            if (r.data.length <= 0) {
              that.nodata.mapChartData = true;
              return;
            } else {
              that.nodata.mapChartData = false;
            }
          });
        });
      }

      //热点事件
      let datas1 = {
        type: that.curRankType,
        province: province,
        city: city,
        county: county,
        start_time: that.startTime,
        end_time: that.endTime,
      };
      //情绪判断
      //that.pieEmotionData = [{"name":"喜悦","value":6},{"name":"赞扬","value":124},{"name":"愤怒","value":8},{"name":"悲伤","value":7},{"name":"恐惧","value":5},{"name":"厌恶","value":13},{"name":"惊奇","value":16}]
      that.pieColorArr = [];
      that.curEmot = "";
      that.curEmotPer = 0;
      that.pieEmotionData = [];
      that.emotionData = [];
      that.defaultWords = [];
      that.hotAllRank=[];
      that.$api.get("news/emotion/pie", datas1, (r) => {
        that.$parent.returnCode(r, function () {
          if (r.data.length <= 0) {
            that.nodata.pieEmotionData = true;
            return;
          } else {
            that.nodata.pieEmotionData = false;
          }
          r.data.list.forEach((ele, i) => {
            if (i == 0) {
              that.curEmotPer =
                parseFloat((ele.value / r.data.total) * 100).toFixed(2) + "%";
            }
            that.pieColorArr.push(that.emotIcon[ele.name].color);
          });
          that.curEmot = r.data.max;
          that.curMood = r.data.max;
          if (r.data.max == "中性") {
            that.curEmotPer = "";
            that.curMood = r.data.list[0].name;
          }
          that.pieEmotionData = r.data.list;
          that.datas2 = {
            type: that.curRankType,
            province: province,
            city: city,
            county: county,
            start_time: that.startTime,
            end_time: that.endTime,
          };

          that.getMapEvent();
        });
      });
      //情绪分析
      that.$api.get("news/emotion/line", datas1, (r) => {
        that.$parent.returnCode(r, function () {
          that.load.emotionData = false;
          that.$parent.loadModal(false);
          r.data.dataName = r.data.dateName;
          that.emotionData = r.data;
          if (r.data.length <= 0) {
            that.nodata.emotionData = true;
            return;
          } else {
            that.nodata.emotionData = false;
          }
        });
      });
      // 热门主题词
      that.$api.get("news/emotion/keywords", datas1, (r) => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.load.defaultWords = false;
          if (r.data.length <= 0) {
            that.nodata.defaultWords = true;
            return;
          } else {
            that.nodata.defaultWords = false;
          }
          that.defaultWords = r.data;
        });
      });
    },
    //地图热点事件列表
    getMapEvent() {
      let that = this;
      that.hotAllRank = [];
      that.datas2.mood = that.moodList[that.curMood];

      that.$api.get("news/emotion/index", that.datas2, (r) => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.load.hotAllRank = false;
          if (r.data.list.length <= 0) {
            that.nodata.hotAllRank = true;
            return;
          } else {
            that.nodata.hotAllRank = false;
          }
          that.hotAllRank = r.data.list.slice(0, 10);
        });
      });
    },
    //地图点击
    fatherMethod(name, id, type) {
      let that = this;
      that.curMapName = name;
      if (type == 2) {
        that.curCityMapName = name;
        that.curFullName = that.curProvMapName + "-" + that.curCityMapName;
        that.dataAjax(type);
      } else if (type == 3) {
        that.curMapName=that.curProvMapName
        that.curAreaMapName = name;
        if (that.curCityMapName == "") {
          that.curFullName = that.curProvMapName + "-" + that.curAreaMapName;
        } else {
          that.curFullName =
            that.curProvMapName +
            "-" +
            that.curCityMapName +
            "-" +
            that.curAreaMapName;
        }
        that.dataAjax(type);
      } else {
        that.curProvMapName = name;
        that.curFullName = that.curProvMapName;
        that.dataAjax();
      }
      that.$refs.citySelect.fullName = that.curFullName;

      that.$refs.citySelect.clickCityMap(name, type);
    },
    // 地区筛选
    citySelect1(name) {
      let province = name[0];
      let fullCity = name[1];
      let city = name[2];
      let county = name[4];
      let type = name[5];
      let that = this;
      that.curAreaMapName =
        county === "全市" || county === "选择区县" ? "" : county;
      that.curCityMapName =
        fullCity === "全省" || fullCity === "选择城市" || city === "全市"
          ? ""
          : fullCity;
      if (province === "全国") {
        that.curMapName = "全国";
        that.curProvMapName = "";
      } else {
        that.curMapName = province;
        that.curProvMapName = that.curMapName;
      }
      if (that.curAreaMapName != "") {
        if (type != 2) {
          that.curMapName = fullCity;
        }
        that.dataAjax(4);
      } else if (that.curCityMapName != "") {
        that.curMapName = fullCity;
        if (type == 5) {
          that.dataAjax(type);
        } else {
          that.dataAjax(2);
        }
      } else {
        that.dataAjax();
      }
      that.curFullName = that.$refs.citySelect.fullName;
    },
    changeTime() {
      let that = this;
      that.clearListData();
    },
    disabledDate(time) {
      return time > this.maxTime;
      //return time < this.min || time > this.max
    },
    clearListData() {
      let that = this;
      that.hotAllRank = [];
      if (that.curAreaMapName != "") {
        that.dataAjax(4);
      } else if (that.curCityMapName != "") {
        that.dataAjax(2);
      } else {
        that.dataAjax();
      }
    },
    selectedDate(date) {
      let that = this;

      // that.startTime = that.$utils.dateConversion(that.timeRange[0], 1);
      // that.endTime = that.$utils.dateConversion(that.timeRange[1], 1);

      that.startTime=that.$utils.dateConversion(that.timeRange[0], 0)+ ' '+'00:00:00'//开始时间设置为00:00:00
      that.endTime = that.$utils.dateConversion(that.timeRange[1], 0)+ ' '+'23:59:59'//结束时间设置为23:59:59


      that.clearListData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/emotionArea.vue